
import {mapMutations, mapGetters} from 'vuex'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {
fetchResourceDetail,
addToCart,
deleteFromCart,
addToCollection,
deleteFromCollection,
getRelatedArticles
} from '@/api/resource'
import {fetchCart} from '@/api/cart'
import {formatNumInTenThousand, formatDate} from '@/utils/index'

export default {
computed: {
...mapGetters([
'taxonomyList'
])
},
components: {
Previewer,
TransferDom
},
data () {
return {
type: '',
taxonomy: '',
id: '',
detailData: {
quote: {},
analysis: {},
category: {},
cart: {},
platform: {}
},
collectionStatus: false,
cartNum: 0,
relatedArticleData: [],
unfold: false,
qrImg: [],
selectedPrice: 0
}
},
methods: {
...mapMutations({
setTitleVuex: 'SET_TITLE'
}),
changeNavTitle (navTitle) {
this.setTitleVuex(navTitle)
document.title = navTitle
},
getDetail () {
fetchResourceDetail(this.type, this.id).then(resp => {
this.detailData = {
...resp.data,
publishRate: formatNumInTenThousand(resp.data.analysis.publish_rate),
pcBaiduRank: formatNumInTenThousand(resp.data.analysis.pc_baidu_rank),
mBaiduRank: formatNumInTenThousand(resp.data.analysis.m_baidu_rank),

avgReadNumTop: formatNumInTenThousand(resp.data.analysis.avg_read_num_top),
avgReadNumUntop: formatNumInTenThousand(resp.data.analysis.avg_read_num_untop),
avgLikeNumTop: formatNumInTenThousand(resp.data.analysis.avg_like_num_top),
avgLikeNumUntop: formatNumInTenThousand(resp.data.analysis.avg_like_num_untop),
maxReadNum: formatNumInTenThousand(resp.data.analysis.max_read_num),

avgRetweetNum: formatNumInTenThousand(resp.data.analysis.avg_retweet_num),
avgLikeNum: formatNumInTenThousand(resp.data.analysis.avg_like_num),
avgCommentNum: formatNumInTenThousand(resp.data.analysis.avg_comment_num),
maxRetweetNum: formatNumInTenThousand(resp.data.analysis.max_retweet_num),
maxLikeNum: formatNumInTenThousand(resp.data.analysis.max_like_num),
maxCommentNum: formatNumInTenThousand(resp.data.analysis.max_comment_num),

fansNum: formatNumInTenThousand(resp.data.analysis.fans_num),
avgAudienceNum: formatNumInTenThousand(resp.data.analysis.avg_audience_num),
maxAudienceNum: formatNumInTenThousand(resp.data.analysis.max_audience_num),

avgPlayNum: formatNumInTenThousand(resp.data.analysis.avg_play_num),
readNum: formatNumInTenThousand(resp.data.analysis.avg_read_num),

priceValidityEnd: resp.data.quote.price_validity_end
? formatDate(resp.data.quote.price_validity_end)
: '',
price: resp.data.quote.price,
priceSecond: resp.data.quote.price_second,
cartStatus: resp.data.cart && resp.data.cart.created_at
}

this.collectionStatus = resp.data.collection && resp.data.collection.created_at
this.changeNavTitle(this.detailData.name)
this.selectedPrice = this.detailData.price || this.detailData.priceSecond
this.qrImg = [
{
src: resp.data.qrcode
}
]

getRelatedArticles(resp.data.account_id, resp.data.taxonomy, 10).then(res => {
this.relatedArticleData = res.data
if (this.relatedArticleData.length <= 3) {
this.unfold = true
}
})
}).catch((e) => console.log('error', e))
},
changePriceStatus (num) {
if (num === 1) {
this.selectedPrice = this.detailData.quote.price
}
if (num === 2) {
this.selectedPrice = this.detailData.quote.price_second
}
},
handleAddToCart (action) {
const top = this.selectedPrice === this.detailData.price
? this.taxonomy.priceType[0]
: this.taxonomy.priceType[1]
addToCart(this.detailData.id, this.type, top).then(res => {
if (action === 'goToCart') {
this.$router.push('/cart')
} else {
this.getDetail()
}
}).catch((e) => console.log('error', e))
},
handleDeleteFromCart () {
deleteFromCart(this.detailData.cart.item_id).then(resp => {
this.getDetail()
}).catch((e) => console.log('error', e))
},
handleAddToCollection () {
addToCollection(this.detailData.id, this.type).then(resp => {
this.getDetail()
}).catch((e) => console.log('error', e))
},
handleDeleteFromCollection () {
deleteFromCollection(this.detailData.collection.id).then(resp => {
this.getDetail()
}).catch((e) => console.log('error', e))
},
handleCollectionClick () {
this.collectionStatus ? this.handleDeleteFromCollection() : this.handleAddToCollection()
},
getCartNum () {

if (this.profile && this.profile.id) {
fetchCart(this.type).then(resp => {
this.cartNum = resp.data.length
}).catch((e) => console.log('error', e))
}
},

goToCart () {
let idx = 0
if (this.type === 'news') {
idx = 0
}
if (this.type === 'woa') {
idx = 1
}
if (this.type === 'weibo') {
idx = 2
}
if (this.type === 'live') {
idx = 3
}
if (this.type === 'video') {
idx = 4
}
this.$router.push('/cart?tab=' + idx)
},
unfoldRelatedArticles () {
this.unfold = true
},
openQrcode () {
this.$refs.previewer.show(0)
}
},
mounted () {
if (this.$route.query.type && this.$route.params.id) {
this.type = this.$route.query.type
this.id = this.$route.params.id
this.taxonomyList.map(item => {
if (item.tabType === this.type) {
this.taxonomy = item
}
})
}
this.getDetail()
this.getCartNum()
}
}



// WEBPACK FOOTER //
// ./src/pages/mediaDetail/index.vue